import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { SecureLocalStorage } from 'src/app/shared/services/secure-local-storage';
import { MenuItems } from '../../core/menu/menu-items/menu-items';
import { WebService } from '../../shared/services/web.service';

declare var $: any, bootbox: any; 
@Component({
  selector: 'app-verifier-login',
  templateUrl: './verifier-login.component.html',
  styleUrls: ['./verifier-login.component.css']
})
export class VerifierLoginComponent implements OnInit {
  verifierLogin = new Verifierlogin();
  verifierLogins = new Verifierlogins();
  Apiurl: string;
  @ViewChild('AdminLogin') AdminLoginForm: NgForm;
  validation: boolean = false;

  constructor(private webService: WebService, private router: Router, private secureLS: SecureLocalStorage, public menuItems: MenuItems)
  {
    localStorage.clear();
    this.secureLS.removeStorage();
  }
  ngOnInit() {
    setTimeout(() => { $('#newsTicker1').breakingNews(); }, 500)
     this.noBack();		
  }
  noBack() {
    window.history.forward()
  }
  Login() {
    
    if (this.AdminLoginForm.valid) {
      this.validation = false;
      var user_name = this.verifierLogin.Loginname;
      var Password = this.verifierLogin.Password;


      this.verifierLogins.Loginname = this.webService.encryptData(user_name);

      this.verifierLogins.Password = this.webService.encryptData(Password);
     


      this.Apiurl = "api/Admin/AdminLogin";
      this.webService.postData(this.Apiurl, this.verifierLogins).subscribe((data: any) => {
        debugger;
        if (data != null) {
          if (data.statusCode == 200) {
            this.secureLS.setStorage('veriferRole', data.role);
            this.secureLS.setStorage('verifierName', data.username);
            this.secureLS.setStorage('veriferId', data.ekyc_code);
            
             
            debugger;
            if (data.role == "Admin") {

              localStorage.setItem('verifierLoginAs', data.role);
              this.secureLS.setStorage('RMTk', data);
              this.secureLS.setStorage('TokenId', data.token);
              this.secureLS.setStorage('MenuList', this.menuItems.getAll());
              console.log(this.secureLS.getStorage('MenuList'))
              const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
              this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
              localStorage.setItem('Verifier_User_Name', user_name);
              this.router.navigate(['/admin/VerifierOtherLogin']);


            }
            else if (data.role == "Call Center") {

              localStorage.setItem('verifierLoginAs', data.role);
              this.secureLS.setStorage('RMTk', data);

              this.secureLS.setStorage('MenuList', this.menuItems.getAll());
              console.log(this.secureLS.getStorage('MenuList'))
              const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
              this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
              localStorage.setItem('Verifier_User_Name', user_name);
              this.router.navigate(['/admin/Reports/ModelStage']);

            }
            else if (data.role == "KYC Verifier") {
              debugger;
              localStorage.setItem('verifierLoginAs', data.role);
              this.secureLS.setStorage('TokenId', data.token);
              this.secureLS.setStorage('RMTk', data);
              /*this.secureLS.setStorage('Verifier_User_Name', data.Verifier_User_Name);*/
              localStorage.setItem('Verifier_User_Name', user_name);
              const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
              this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
             
             
              if (data.userBusinesstype == "P000002") {
                this.router.navigate(['/admin/pmsadmindashboard']);
              }
              else {
                this.router.navigate(['/admin/admindashboard']);
              }
              this.secureLS.setStorage('MenuList', this.menuItems.getAll());
              console.log(this.secureLS.getStorage('MenuList'))
              localStorage.setItem('Verifier_User_Name', user_name);
            }
            else if (data.role == "Sub Admin") {
              debugger
              localStorage.setItem('verifierLoginAs', data.role);
              this.secureLS.setStorage('TokenId', data.token);
              this.secureLS.setStorage('RMTk', data);
              this.secureLS.setStorage('MenuList', this.menuItems.getAll());
              const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
              this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
              this.router.navigate(['/admin/application']);

            }
            else if (data.role == "Partner") {
              debugger
              localStorage.setItem('verifierLoginAs', data.role);
              this.secureLS.setStorage('TokenId', data.token);
              this.secureLS.setStorage('RMTk', data);
              this.secureLS.setStorage('MenuList', this.menuItems.getAll());
              const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
              this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
              this.router.navigate(['/dashboard/branchpartner']);

            }
            else if (data.role == "ARMF Verifier" || data.role == "ARMF Admin") {
              localStorage.setItem('verifierLoginAs', data.role);
              this.secureLS.setStorage('TokenId', data.token);
              this.secureLS.setStorage('RMTk', data);
              this.secureLS.setStorage('MenuList', this.menuItems.getAll());
              const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
              this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
              this.router.navigate(['/armf/dashboard']);
            }

            else if (data.role == "IBS") {
              debugger
              localStorage.setItem('verifierLoginAs', data.role);
              this.secureLS.setStorage('TokenId', data.token);
              this.secureLS.setStorage('RMTk', data);
              this.secureLS.setStorage('MenuList', this.menuItems.getAll());
              const time_to_login = Date.now();// + 12 * 3600 * 1000 //15 minutes;
              this.secureLS.setStorage('timer', JSON.stringify(time_to_login));
              this.router.navigate(['/dashboard/branchpartner']);

            }

            localStorage.setItem('Verifier_User_Name', user_name);
          }
          else {
            bootbox.alert(data.message);
          }
        }
      }, error => {
          console.log('Error ', error);
          //Change message because of wrong message display.
          // Modified by Yasmin.
        bootbox.alert({
          message: "<div class='text-center'><h6><i class='fa fa-times-circle fa-2x text-danger mb-3'></i><br>Please Enter Correct User ID And Password.</h6></div>",
          size: 'large'
        });
          this.AdminLoginForm.reset();
      })

    }
    else {
      this.validation = true;
    }
  }

  
}

export class Verifierlogin {

  Loginname: string;
  Password: string;
  }
export class Verifierlogins {

  Loginname: string;
  Password: string;
}
